import { createRouter, createWebHistory } from 'vue-router'
import { useLanguageCode } from '@/locales/languageMiddleware'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
   {path:'/',name:"processManagement",component:() => import('../views/processManagement/index.vue')},
    {path:'/flowDesigner/:id?',name:'flowDesigner',component:()=>import('../views/processManagement/ProcessDesignerPage.vue'),props:true},
    {path:'/flowDesigner/copy/:copyId',name:'flowDesignerCopy',component:()=>import('../views/processManagement/ProcessDesignerPage.vue'),props:true},
    {path:'/startNewProcess/:processDefinitionId',name:'startNewProcess',component:()=>import('../views/processManagement/ProcessForm.vue'),props:true},
    {path:'/approver/:nodeInstanceId',name:'approvePage',component:()=>import('../views/processManagement/ProcessForm.vue'),props:true},
    {path:'/emailApprover/:nodeInstanceId',name:'emailApprovePage',component:()=>import('../views/processManagement/EmailApproveForm.vue')
      ,props:route=>({
        nodeInstanceId:route.params.nodeInstanceId,
        tenantId:route.query.tenantId,
        accessToken:route.query.accessToken,
      })},
    {path:'/processGraphPage/:instanceId',name:'processGraphPage',component:()=>import('../views/processManagement/ProcessGraphPage.vue'),props:true},
    {path:'/relatedToMe',name:'RelatedToMe',component:()=>import('../views/processManagement/RelatedToMe.vue'),props:true},
    {path:'/languageCulture',name:'LanguageCulture',component:()=>import('../views/processManagement/LanguageCulture.vue'),}
  ]
})
useLanguageCode(router);
export default router
